import { render, staticRenderFns } from "./PropertyForm.vue?vue&type=template&id=3806c553&scoped=true&"
import script from "./PropertyForm.vue?vue&type=script&lang=ts&"
export * from "./PropertyForm.vue?vue&type=script&lang=ts&"
import style0 from "./PropertyForm.vue?vue&type=style&index=0&id=3806c553&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3806c553",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
